import { gql } from "@apollo/client"
import { useQuery } from "@oysterhr/core"
import { Engagement } from "@oysterhr/schema"
import { ENGAGEMENT_FRAGMENT } from "./fragments"

export const EQUITY_TAB_QUERY_NAME = "EquityGrantsEngagement"

export const EQUITY_TAB_QUERY = gql`
  query ${EQUITY_TAB_QUERY_NAME}($engagementId: ID!) {
    engagement(engagementId: $engagementId) {
      ...EquityEngagementFragment
    }
  }

  ${ENGAGEMENT_FRAGMENT}
`

export const useEquityEngagement = (engagementId: string) =>
  useQuery<{ engagement: Engagement }>(EQUITY_TAB_QUERY, {
    variables: { engagementId },
    fetchPolicy: "cache-and-network",
  })
